













































import { Component, Vue } from 'vue-property-decorator'
import knowledgeBaseApi from '@/api/knowledge-base'
import {KnowledgeBaseArticleATableDto} from "@/global";

@Component({
})
export default class AdminAccess_KnowledgeBaseArticles extends Vue {
    scrollbarSettings = {
        suppressScrollY: true
    };

    table = {
        isLoading: false,
        currentPage: 1,
        totalCount: -1,

        fields: [
            {
                key: 'actions',
                label: ''
            },
            {
                key: 'categoryName',
                label: 'Категорія'
            },
            {
                key: 'title',
                label: 'Назва'
            },
            {
                key: 'contentPreview',
                label: 'Опис'
            },
            {
                key: 'updatedOn',
                label: 'Оновлено'
            },
        ]
    };

    tableItemsProvider(ctx, callback: (items: KnowledgeBaseArticleATableDto[]) => void) {
        this.table.isLoading = true;

        knowledgeBaseApi.articlesForTable(this.table.currentPage, articlesResult => {
            callback(articlesResult.items);

            this.table.totalCount = articlesResult.totalCount;
            this.table.isLoading = false;
        }, errorMessage => {
            callback([]);

            this.table.isLoading = false;
        });

        return null;
    }
}
